import React from 'react';

export default class Table extends React.Component {
    
    constructor(props){
      super(props);
      this.getHeader = this.getHeader.bind(this);
      this.getRowsData = this.getRowsData.bind(this);
      this.getKeys = this.getKeys.bind(this);
    }
    
    getKeys = function(){
      const {data}= this.props;
      return Object.keys(data[0] || [{'#': 0}]);
    }
    
    getHeader = function(){
      var keys = this.getKeys();
      return keys.map((key, index)=>{
        return (
        <th key={key}className="sticky-header table-header-yellow" style={{paddingLeft:15}}>{key}</th>)
      })
    }
    
    getRowsData = function(){
      const {data}= this.props;
      var items = data || [{'#': 0}];
      var keys = this.getKeys();
      return items.map((row, index)=>{
        return <tr key={index}>
            <RenderRow key={index} data={row} keys={keys}/>
            </tr>
      })
    }
  
    
    render() {
        return (
          <div className="table-wrapper-scroll-y my-custom-scrollbarquery">
          <table id="dataTableQuery" className="display" style={{width: '100%'}}>
              <thead className="table-header">
              <tr>
                  {this.getHeader()}</tr>
              </thead>
              <tbody>
              
              {this.getRowsData()}
              </tbody>
          </table>
      </div>
        )
        
    }
}

const RenderRow = (props) =>{
  return props.keys.map((key, index)=>{
    return <td key={props.data[key]}  style={{paddingLeft:15}}>{props.data[key]}</td>
  })
}
